import dayjs from 'dayjs';


/**
 * 格式化日期时间戳，返回对应时间格式
 * 参数： timestamp, 时间戳
 * 返回： string, 今天的时间戳，返回 时分秒（14:20:20）；今年非今天的日期，返回 月日（04-02）；非今年的日期，返回 年月日（2020-01-01）
 */
export function formatMsgDate(time) {
  const timestamp = time ? Number(time) : '';
  const isToday = dayjs().isSame(dayjs(timestamp), 'day');
  const isThisYear = dayjs().isSame(dayjs(timestamp), 'year');

  if (!isThisYear) {
    return dayjs(timestamp).format('YYYY-MM-DD');
  }

  if (!isToday) {
    return dayjs(timestamp).format('MM-DD');
  }

  return dayjs(timestamp).format('HH:mm:ss');
}
